function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 1.856C32 2.4 31.808 2.816 31.456 3.2L18.656 16 31.456 28.8C31.808 29.184 32 29.6 32 30.144 32 30.656 31.808 31.104 31.456 31.456 31.104 31.808 30.656 32 30.144 32 29.6 32 29.184 31.808 28.8 31.456L16 18.656 3.2 31.456C2.816 31.808 2.4 32 1.856 32 1.312 32 0.896 31.808 0.544 31.456 0.192 31.104-4.44089e-15 30.656-4.44089e-15 30.144-4.44089e-15 29.6 0.192 29.184 0.544 28.8L13.344 16 0.544 3.2C0.192 2.816-4.88498e-15 2.4-4.88498e-15 1.856-4.88498e-15 1.312 0.192 0.896 0.544 0.544 0.896 0.192 1.344-4.44089e-15 1.856-4.44089e-15 2.368-4.44089e-15 2.816 0.192 3.2 0.544L16 13.344 28.8 0.544C29.184 0.192 29.6-4.88498e-15 30.144-4.88498e-15 30.656-4.88498e-15 31.104 0.192 31.456 0.544 31.808 0.896 32 1.344 32 1.856Z",
  stroke: "none",
  strokeWidth: 1,
  strokeLinecap: "butt",
  fillOpacity: 1
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    overflow: "hidden",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.323c7d58.svg";
export { ForwardRef as ReactComponent };